import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetRevisionDeepLicensesResponse } from '../../../../shared/licenses/response';

const STALE_TIME = 1000 * 30; // 30 seconds

async function getRevisionDeepLicenses(locator: string) {
  return get<GetRevisionDeepLicensesResponse>(`/api/revisions/${nuc(locator)}/deeplicenses`);
}

export const getQueryKey = (locator: string): QueryKey => ['revisions', locator, 'deeplicenses'];

/**
 * Hook to fetch deep licenses for a revision.
 *
 * @param {string} locator The revision locator.
 * @param {boolean} shouldFetch Whether to fetch the data. Defaults to true.
 */
export function useRevisionDeepLicenses(locator: string, shouldFetch = true) {
  return useQuery<GetRevisionDeepLicensesResponse>({
    queryKey: getQueryKey(locator),
    queryFn: () => getRevisionDeepLicenses(locator),
    staleTime: STALE_TIME,
    enabled: shouldFetch && !!locator,
  });
}
